/**
 * Fetch environment configurations from the backend API
 */
export const fetchEnvironments = async () => {
  const apiUrl = `${process.env.REACT_APP_HUB_BACKEND_HOSTNAME}/api/environments`;
  try {
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      cache: 'no-cache'
    });
    if (!response.ok) throw new Error('Failed to fetch environments from backend');
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching environments from backend:', error);
    throw new Error('Failed to fetch environments from backend');
  }
};

/**
 * Extract environment name from endpoint URL for data restriction
 */
export const getEnvironmentFromEndpoint = (endpoint) => {
  if (!endpoint) return null;
  try {
    const url = new URL(endpoint);
    const hostname = url.hostname;
    const parts = hostname.split('.');
    if (parts.length >= 2) {
      return parts[1];
    }
  } catch (error) {
    console.error('Error parsing endpoint URL:', error);
  }
  return null;
};

/**
 * Get the base URL for API calls - prioritizes selected endpoint over env variable
 * Now expects environmentName and environments as arguments
 */
export const getApiBaseUrl = (environmentName, environments) => {
  const selectedEndpoint = environments[environmentName];
  if (selectedEndpoint) {
    return selectedEndpoint;
  }
  return process.env.REACT_APP_HUB_BACKEND_HOSTNAME || '';
}; 